import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "bootstrap/dist/css/bootstrap.min.css";
import * as React from "react";
import "react-notifications-component/dist/theme.css";
import { Col, Container, Row } from "reactstrap";
import { showAlert } from "../common/functions";
import ReleaseNotificationDetail from "./releaseNotificationDetail";

class ReleaseNotificationPage extends React.Component {
	componentDidMount() {
		var alertMessage = window.localStorage.getItem("alertMessage");
		if (alertMessage && alertMessage !== "") {
			showAlert(alertMessage, false);
			window.localStorage.setItem("alertMessage", "");
		}

		document.title =
			"Release Notifications - Daily Audio Bible Administration";
	}

	render() {
		return (
			<div>
				<Container>
					<Row>
						<Col lg="12">
							<div>
								<h2>
									<FontAwesomeIcon icon={faBell} />
									<span data-testid="releaseNotificationPageTitle">
										{" "}
										Release Notifications
									</span>
								</h2>
								<hr />
								<ReleaseNotificationDetail />
							</div>
						</Col>
						<Col />
					</Row>
				</Container>
			</div>
		);
	}
}

export default ReleaseNotificationPage;
